/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {DataServerConfig} from '../config/api-config';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class VisitorProfileApiService {
  constructor(private readonly client: AdnApiClientService) {
  }

  getVisitor(folderId: string, browserId: string): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: DataServerConfig.obtain().getUri('synchronous/visitor'),
      params: {folderId, browserId}
    });
  }
}
